<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400px"
      transition="dialog-transition"
      @input="onDialogOpen"
    >
      <v-sheet>
        <v-toolbar dark class="primary">
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Actualizar precio</v-toolbar-title>
        </v-toolbar>
        <v-form
          ref="form"
          v-model="valid"      
        >
          <v-container>
            <date-picker
              v-model="vigencia"
              label="Vigencia"
            ></date-picker>
            <v-text-field
              v-model="pleno"
              label="Pleno"
              type="number"
              prepend-icon="mdi-currency-usd"
              color="primary"
              :rules="rules.pleno"
            ></v-text-field>
            <v-text-field
              :value="(subsidio + usuario)"
              readonly
              label="Total subsidio"
              type="number"
              prepend-icon="mdi-currency-usd"
              color="primary"
            ></v-text-field>
            <v-text-field
              v-model="subsidio"
              label="Subsidio"
              type="number"
              prepend-icon="mdi-currency-usd"
              color="primary"
              :rules="rules.subsidio"
            ></v-text-field>
            <v-text-field
              v-model="usuario"
              label="Usuario"
              type="number"
              prepend-icon="mdi-currency-usd"
              color="primary"
              :rules="rules.usuario"
            ></v-text-field>
            <v-text-field
              v-model="detalle"
              label="Detalle"
              prepend-icon="mdi-text-short"
              color="primary"
              :rules="rules.detalle"
            ></v-text-field>
            <v-footer>
              <v-btn
                :disabled="!updatable && !$can('precios.update')"
                color="primary"
                @click="onSubmit"
                :loading="loading"
              >
                Actualizar
              </v-btn>
            </v-footer>
          </v-container>
        </v-form>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DatePicker from '@/components/DatePicker'
export default {
  name: 'PreciosEditComponent',
  components: {
    'date-picker': DatePicker
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valid: false,
    }
  },
  computed: {
    ...mapGetters('Precios', ['edited', 'rules', 'loading', 'updatable']),
    dialog: {
      get () {
        return this.selected
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    vigencia: {
      get () {
        return this.edited.vigencia
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          vigencia: value
        })
      }
    },
    pleno: {
      get () {
        return this.edited.pleno
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          pleno: parseFloat(value)
        })
      }
    },
    subsidio: {
      get () {
        return this.edited.subsidio
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          subsidio: parseFloat(value)
        })
      }
    },
    usuario: {
      get () {
        return this.edited.usuario
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          usuario: parseFloat(value)
        })
      }
    },
    detalle: {
      get () {
        return this.edited.detalle
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          detalle: value
        })
      }
    },
  },
  methods: {
    ...mapActions('Precios', ['onUpdate', 'onFetch', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Precios', ['setEdited']),
    onSubmit(event) {
      event.preventDefault();
      this.$refs.form.validate();
      if (this.valid) {
        this.onUpdate().then(response => {
          this.onClearEdited();
          this.onClearSelected();
          this.onFetch();
          this.dialog = false
        });
      }
    },
    onClose (event) {
      event.preventDefault()
      this.dialog = false
    },
    onDialogOpen () {
      // Esperamos a que el diálogo esté completamente abierto
      this.$nextTick(() => {
        if (this.dialog) {
          window.addEventListener('keydown', this.handleKeyboard);
        }
        else {
          window.removeEventListener('keydown', this.handleKeyboard);
          this.subsidio = 0;
          this.usuario = 0;
          this.pleno = 0;
        }
      });
    },
  },
}
</script>
